import React from 'react';
import FaqHeroRo from '../../components/faq/ro/FaqHeroRo';
import FaqListRo from '../../components/faq/ro/FaqListRo';
import FaqCtaRo from '../../components/faq/ro/FaqCtaRo';

const FaqPageRo = () => (
  <main>
    <FaqHeroRo />
    <FaqListRo />
    <FaqCtaRo />
  </main>
);

export default FaqPageRo;